import { Stack, Typography } from "@mui/material";
import CustomInformationButton from "./CustomInformationButton";
import { CustomTooltip } from "@web-applications/allinga-web-components";

interface CustomTooltipTypographyProps {
  title: string;
  tooltip?: string;
}

function CustomTooltipTypography({
  title,
  tooltip,
}: CustomTooltipTypographyProps): JSX.Element | null {
  return (
    <Stack direction="row" gap={0.5}>
      <Typography variant="subtitle1">{title}</Typography>
      {tooltip && tooltip !== "" && (
        <CustomTooltip
          title={tooltip}
          placement="bottom"
          disableHoverListener={false}
          forceShow
        >
          <CustomInformationButton />
        </CustomTooltip>
      )}
    </Stack>
  );
}

export default CustomTooltipTypography;
